// START IMPORTS
import { CookiesStorage } from '@ltvco/refresh-lib';
import { useReactivation } from '@ltvco/refresh-lib/payments';
import {
  invalidateSession,
  isUserLoggedIn,
  useSession,
} from '@ltvco/refresh-lib/v1';
import { useQueryClient } from '@ltvco/refresh-lib/vendors';
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Internal - utils
import { goToLogin } from 'utils/goToLogin';
// END IMPORTS

// START INTERFACES_AND_TYPES
interface AuthenticatedRouteProps {
  children: JSX.Element;
}
// END INTERFACES_AND_TYPES

export function AuthenticatedRoute({ children }: AuthenticatedRouteProps) {
  // START HOOKS_AND_QUERIES
  const {
    session: { account },
  } = useSession(); // should be replaced by the user_info object
  const queryClient = useQueryClient();
  const location = useLocation();
  useReactivation({ currentPathName: location.pathname });
  // END HOOKS_AND_QUERIES

  // START DERIVED_DATA_AND_UTILS
  const isNonCompliant = account?.account.user_info.noncompliant;
  const cookieStorage = new CookiesStorage();
  const complianceRoutes = [
    '/compliance-form',
    '/noncompliance',
    '/compliance-prohibited',
    '/compliance-permitted',
    '/compliance-recomply',
  ];

  function handleFreshnessHubUsers() {
    if (!account) return;
    if (account?.account?.staff_info?.staff) return;
    if (
      account?.account.user_info?.design_name === 'freshness' ||
      account?.account.user_info?.design_version === 'v2'
    ) {
      window.location.href = 'https://www.peoplesmart.com/app/';
    }
  }
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    handleFreshnessHubUsers();
  }, [account]);
  // END EFFECTS

  // START EARLY_RETURNS

  if (!isUserLoggedIn()) {
    const url = location.pathname + location.search + location.hash;

    if (cookieStorage.getValue('loggedin')) {
      invalidateSession();
      queryClient.clear();

      setTimeout(() => {
        window.location.reload();
      }, 500);
    }

    if (
      import.meta.env.VITE_TARGET_ENV &&
      !['production'].includes(import.meta.env.VITE_TARGET_ENV)
    ) {
      return <Navigate to="/login" state={{ next: url }} replace />;
    }
    goToLogin('https://www.peoplesmart.com');
    return null;
  }
  if (isNonCompliant && !complianceRoutes.includes(location.pathname)) {
    return (
      <Navigate to={`/noncompliance`} state={{ from: location }} replace />
    );
  }
  // END EARLY_RETURNS

  // START RENDER
  return children;
  // END RENDER
}
